import React from 'react';
import { connect } from 'react-redux';
import cloneDeep from 'clone-deep';

import Schedule from '../components/Scheduler';
import Cell from '../containers/CellContainer';
import HeaderCell from '../containers/HeaderCellContainer';

const mapStateToProps = state => ({
    schedule: state.schedule,
    loading: state.loading,
    schedulePersonal: state.schedulePersonal,
    days: state.days,
    tSes: state.tSes,
    tSesList: state.tSesList,
    rowTitlePosition: state.rowTitlePosition,
});


const ScheduleContainer = ({schedule, loading, schedulePersonal, days, tSes, tSesList, rowTitlePosition}) => {

    let beginDay = 0;
    let dates = ['Врач'];
    let dateStart = new Date();

    const
        green = 30,
        red = 0;

    const setColor = (percent) => {
        percent = percent * 100;

        if (percent >= green) return "#4caf50";
        if (percent > red && percent < green) return "#ff9800";
        if (percent === red) return "#f44336";

        return '#fff'
    };

    const getDateString = (date) => {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        return (day < 10 ? '0' + day : day) + '.' + (month < 10 ? '0' + month : month) + '.' + year
    };

    if (days > 28) beginDay = days - 28;

    for (let i = beginDay; i < days; i++) {
        let nextDate = new Date();
        nextDate.setDate(dateStart.getDate() + i);

        dates.push(getDateString(nextDate))
    }

    const makeTable = () => {
        let tableTemplate;
        let tempSchedule;

        if (tSes !== 'all' && tSes !== 'all-detail') {
            let number = 0;

            tempSchedule = cloneDeep(schedule);
            tableTemplate = tempSchedule.sort((a, b) => {
                if (a.specialty > b.specialty) {
                    return 1;
                }
                if (a.specialty < b.specialty) {
                    return -1;
                }
            }).map((row) => {
                if (row.pers === tSes) {
                    number++;
                    const columns = makeColumns(row, dates, number, true);

                    if (columns) return <tr key={row.name + row.specialty + number} align="center">{columns}</tr>
                }
            });
        } else {
            if (tSes === 'all') {
                tempSchedule = cloneDeep(schedule);

                for (let i = 0; i < tempSchedule.length; i++) {
                    let doctor = tempSchedule[i].name + '_' + tempSchedule[i].specialty;
                    for (let j = i + 1; j < tempSchedule.length; j++) {
                        if (tempSchedule[j].name + '_' + tempSchedule[j].specialty === doctor) {
                            let double = tempSchedule.splice(j, 1)[0];
                            tempSchedule[i].receptions = sumData(tempSchedule[i], double);
                            j--;
                        }
                    }
                }

                tableTemplate = tempSchedule.sort((a, b) => {
                    if (a.specialty > b.specialty) {
                        return 1;
                    }
                    if (a.specialty < b.specialty) {
                        return -1;
                    }
                }).map((row, i) => {
                    const columns = makeColumns(row, dates, i + 1, true);

                    if (columns) return <tr key={row.name + row.specialty + i} align="center">{columns}</tr>
                });
            } else {
                tempSchedule = cloneDeep(schedule);

                for (let i = 0; i < tempSchedule.length; i++) {
                    let doctor = tempSchedule[i].name + '_' + tempSchedule[i].specialty;
                    tempSchedule[i].sessions = [{
                        pers: tempSchedule[i].pers,
                        receptions: tempSchedule[i].receptions
                    }];
                    for (let j = i + 1; j < tempSchedule.length; j++) {
                        if (tempSchedule[j].name + '_' + tempSchedule[j].specialty === doctor) {
                            let double = tempSchedule.splice(j, 1)[0];
                            tempSchedule[i].sessions.push({
                                pers: double.pers,
                                receptions: double.receptions
                            });
                            j--;
                        }
                    }
                }

                tableTemplate = tempSchedule.sort((a, b) => {
                    if (a.specialty > b.specialty) {
                        return 1;
                    }
                    if (a.specialty < b.specialty) {
                        return -1;
                    }
                }).map((row, i) => {
                    let rows = [];

                    for (let j = 0; j < row.sessions.length; j++) {
                        row.sessions[j].name = row.name;
                        row.sessions[j].specialty = row.specialty;
                        rows.push(
                            <tr key={row.name + row.specialty  + j} align="center">
                                {makeColumns(row.sessions[j], dates, i + 1, j === 0, row.sessions[j].pers, j === 0 ? row.sessions.length : 0)}
                            </tr>
                        )
                    }

                    if (rows) return rows.map(row => (row))
                });
            }
        }

        return tableTemplate
    };

    const makeColumns = (row, dates, position, doctor, pers, persCount) => {
        const { receptions } = row;
        let doctorName = '';

        if (row.name.split('_').length >= 3) {
            doctorName = 'Врач ';

            for (let i = 0; i < row.name.split('_').length; i++) {
                doctorName += row.name.split('_')[i][0]
            }
        } else {
            doctorName = row.name
        }

        let columns = [];

            if (doctor) {
                columns.push(
                    <HeaderCell
                        position={position}
                        rowSpan={persCount ? persCount : 1}
                        content={position}
                    />,
                    <HeaderCell
                        position={position}
                        style={{wordBreak: 'break-word', width: 260}}
                        rowSpan={persCount ? persCount : 1}
                        content={<div>
                            <span>
                                {doctorName}
                            </span>
                            <p style={{margin: 0}}>
                                <span style={{fontSize: 12, color: '#949494'}}>{row.specialty.replace(/_/g,' ')}</span>
                            </p>
                        </div>}
                    />
                );
            }

            if (pers) {
                let persTitle;

                tSesList.forEach(tSes => {
                    if (tSes.pers === pers) persTitle = tSes.title
                });

                columns.push(
                    <td style={{wordBreak: 'break-word', width: 200}}>
                        {persTitle}
                    </td>
                );
            }

            let rowSummary = fillRow(row, receptions, dates, columns, position);

            columns.splice(doctor ? (tSes === 'all-detail' ? 3 : 2) : 1, 0, (
                <td style={{wordBreak: 'break-word', width: 20}} bgcolor={setColor(rowSummary.empty / rowSummary.total)} rowSpan={row.sessions && row.sessions.length}>
                    {rowSummary.empty + '/' + rowSummary.total}
                </td>)
            );

            return columns
    };

    const fillRow = (row, receptions, dates, columns, position) => {
        let empty = 0;
        let total = 0;

        for (let i = 1; i < dates.length; i++) {
            if (receptions[dates[i]]) {
                empty = empty + receptions[dates[i]].empty;
                total = total + receptions[dates[i]].total;

                if (tSes !== 'all') {
                    if (tSes === 'all-detail' || row.pers === tSes) {
                        columns.push(
                            <Cell
                                position={position}
                                color={setColor(receptions[dates[i]].empty / receptions[dates[i]].total)}
                                title={'Всего слотов: ' + receptions[dates[i]].total + '. Из них доступно для записи: ' + receptions[dates[i]].empty}
                                text={receptions[dates[i]].empty + '/' + receptions[dates[i]].total}
                            />
                        )
                    }
                } else {
                    columns.push(
                        <Cell
                            position={position}
                            color={setColor(receptions[dates[i]].empty / receptions[dates[i]].total)}
                            title={'Всего слотов: ' + receptions[dates[i]].total + '. Из них доступно для записи: ' + receptions[dates[i]].empty}
                            text={receptions[dates[i]].empty + '/' + receptions[dates[i]].total}
                        />
                    )
                }
            } else {
                columns.push(
                    <Cell
                        position={position}
                        color={"#eeeeee"}
                    />
                )
            }
        }

        return {
            empty: empty,
            total: total
        }
    };

    const sumData = (target, source) => {
        let receptions = Object.assign({},target.receptions);
        let doubleReceptions = Object.assign({},source.receptions);

        for (let date in receptions) {
            if (receptions.hasOwnProperty(date)) {
                if (receptions[date].empty !== undefined && receptions[date].total !== undefined) {
                    if (doubleReceptions.hasOwnProperty(date)) {
                        receptions[date].empty = receptions[date].empty + (doubleReceptions[date].empty ? doubleReceptions[date].empty : 0);
                        receptions[date].total = receptions[date].total + (doubleReceptions[date].total ? doubleReceptions[date].total : 0);
                        doubleReceptions[date].empty = 0;
                        doubleReceptions[date].total = 0
                    }
                }
            }
        }

        for (let date in doubleReceptions) {
            if (doubleReceptions.hasOwnProperty(date)) {
                if (receptions.hasOwnProperty(date)) {
                    if (receptions[date].empty && receptions[date].total) {
                        receptions[date].empty = receptions[date].empty + (doubleReceptions[date].empty ? doubleReceptions[date].empty : 0);
                        receptions[date].total = receptions[date].total + (doubleReceptions[date].total ? doubleReceptions[date].total : 0);
                        doubleReceptions[date].empty = 0;
                        doubleReceptions[date].total = 0
                    }
                } else {
                    receptions[date] = doubleReceptions[date]
                }
            }
        }

        return receptions
    };

    const tableTemplate = makeTable();

    return (
        <Schedule tableTemplate={tableTemplate} schedule={cloneDeep(schedule)} loading={loading} schedulePersonal={schedulePersonal} days={days} dates={dates} tSes={tSes} green={green} red={red} makeColumns={makeColumns} sumData={sumData} setColor={setColor} />
    )
};

export default connect(
    mapStateToProps
)(ScheduleContainer)